module.exports = __webpack_public_path__ + "img/icon-airport.676e631f.svg";